// extracted by mini-css-extract-plugin
module.exports = {"root":"Player_root__oIaaL","cover":"Player_cover__3roBK","button":"Player_button__2GsCW","loading":"Player_loading__3PESj","time":"Player_time__KRlCH"};